module.exports = __webpack_public_path__ + "img/3.7ab86ba5.jpg";